import { render, staticRenderFns } from "./TrendList.vue?vue&type=template&id=0fc5eba7&scoped=true"
import script from "./TrendList.vue?vue&type=script&lang=js"
export * from "./TrendList.vue?vue&type=script&lang=js"
import style0 from "./TrendList.vue?vue&type=style&index=0&id=0fc5eba7&prod&scoped=true&lang=css"
import style1 from "./TrendList.vue?vue&type=style&index=1&id=0fc5eba7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5eba7",
  null
  
)

export default component.exports